import { Navigate, RouteProps } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function ProtectedRoute({ children }: RouteProps) {
	const token = useAuth();

	return token ? <>{children}</> : <Navigate to="/logga-in" />;
}
